import setupSignalRConnection from "@prominentmedia/signalr";
import types from "../actions/actionTypes";
import * as hubMethods from "./hubMethods";
import * as hubCreatedEvents from "./hubCreatedEvents";

//https://stackoverflow.com/a/52653795/3773983

const createMySignalrMiddleWare = store => {

    let hub;

    const onHubCreated = h => { 
       h.on(hubCreatedEvents.DELETED_USER, id => {  
            store.dispatch({
                type: types.DELETED_USER_INCOMING,
                payload: id
            })
        });

        h.on(hubCreatedEvents.UPDATED_USER, id => {         
            store.dispatch({
                type: types.UPDATED_USER_INCOMING,
                payload: id
            })
        });

         h.on(hubCreatedEvents.DELETED_CONTACT, (id,organisationIds) => {  
             store.dispatch({
                 type: types.DELETED_CONTACT_INCOMING,
                 payload: {
                     id, organisationIds
                 }
            })
        });

        h.on(hubCreatedEvents.UPDATED_CONTACT, (id, organisationIds) => {         
            store.dispatch({
                type: types.UPDATED_CONTACT_INCOMING,
                payload: {
                    id, organisationIds
                }
            })
        });

        h.on(hubCreatedEvents.DELETED_INVOICE, (projectId, itemIds) => {  
             store.dispatch({
                 type: types.DELETED_INVOICE_INCOMING,
                 payload: { projectId, itemIds }
            })
        });     

        h.on(hubCreatedEvents.CREATED_INVOICE, (id, itemIds) => {
            store.dispatch({
                type: types.CREATED_INVOICE_INCOMING,
                payload: {id, itemIds}
            })
        });

         h.on(hubCreatedEvents.DELETED_ORGANISATION, id => {  
            store.dispatch({
                type: types.DELETED_ORGANISATION_INCOMING,
                payload: id
            })
        });

        h.on(hubCreatedEvents.UPDATED_ORGANISATION, id => {         
            store.dispatch({
                type: types.UPDATED_ORGANISATION_INCOMING,
                payload: id
            })
        });

         h.on(hubCreatedEvents.DELETED_PHASE, (id, projectId) => {  
             store.dispatch({
                 type: types.DELETED_PHASE_INCOMING,
                 payload: { id, projectId }
            })
        });

        h.on(hubCreatedEvents.UPDATED_PHASE, (id, projectId) => {         
            store.dispatch({
                type: types.UPDATED_PHASE_INCOMING,
                payload: { id, projectId }
            })
        });

         h.on(hubCreatedEvents.DELETED_PROJECT, id => {  
            store.dispatch({
                type: types.DELETED_PROJECT_INCOMING,
                payload: id
            })
        });

        h.on(hubCreatedEvents.UPDATED_PROJECT, (id, complete) => {         
            store.dispatch({
                type: types.UPDATED_PROJECT_INCOMING,
                payload: { id, complete }
            })
        });

         h.on(hubCreatedEvents.DELETED_PROJECTITEM, (id, projectId) => {  
             store.dispatch({
                 type: types.DELETED_PROJECTITEM_INCOMING,
                 payload: { id, projectId }
            })
        });

        h.on(hubCreatedEvents.UPDATED_PROJECTITEM, (id, projectId) => {         
            store.dispatch({
                type: types.UPDATED_PROJECTITEM_INCOMING,
                payload: { id, projectId }
            })
        });

        h.on(hubCreatedEvents.DELETED_PROJECTITEMACTIVITY, (id, itemId, projectId) => {          
             store.dispatch({
                 type: types.DELETED_PROJECTITEMACTIVITY_INCOMING,
                 payload: { id, itemId, projectId }
            })
        });

        h.on(hubCreatedEvents.UPDATED_PROJECTITEMACTIVITY, (id,itemId, projectId) => {         
            store.dispatch({
                type: types.UPDATED_PROJECTITEMACTIVITY_INCOMING,
                payload: { id,itemId, projectId }
            })
        });

         h.on(hubCreatedEvents.DELETED_PROJECTITEMINVOICEAMOUNT, id => {  
            store.dispatch({
                type: types.DELETED_PROJECTITEMINVOICEAMOUNT_INCOMING,
                payload: id
            })
        });

        h.on(hubCreatedEvents.UPDATED_PROJECTITEMINVOICEAMOUNT, id => {         
            store.dispatch({
                type: types.UPDATED_PROJECTITEMINVOICEAMOUNT_INCOMING,
                payload: id
            })
        });

         h.on(hubCreatedEvents.DELETED_PROJECTITEMMILESTONE, (id, itemId, projectId) => {  
             store.dispatch({
                 type: types.DELETED_PROJECTITEMMILESTONE_INCOMING,
                 payload: { id, itemId, projectId }
            })
        });

        h.on(hubCreatedEvents.UPDATED_PROJECTITEMMILESTONE, (id, itemId, projectId) => {         
            store.dispatch({
                type: types.UPDATED_PROJECTITEMMILESTONE_INCOMING,
                payload: { id, itemId, projectId }
            })
        });

        h.on(hubCreatedEvents.DELETED_PROJECTITEMNOTE, (id, itemId, projectId) => {  
             store.dispatch({
                 type: types.DELETED_PROJECTITEMNOTE_INCOMING,
                 payload: { id, itemId, projectId }
            })
        });

        h.on(hubCreatedEvents.UPDATED_PROJECTITEMNOTE, (id,itemId, projectId) => {         
            store.dispatch({
                type: types.UPDATED_PROJECTITEMNOTE_INCOMING,
                payload: { id,itemId, projectId }
            })
        });

         h.on(hubCreatedEvents.DELETED_SITE, (id, organisationId) => {  
             store.dispatch({
                 type: types.DELETED_SITE_INCOMING,
                 payload: { id, organisationId }
            })
        });

        h.on(hubCreatedEvents.UPDATED_SITE, (id, organisationId) => {         
            store.dispatch({
                type: types.UPDATED_SITE_INCOMING,
                payload: {
                    id, organisationId
                }
            })
        });

         h.on(hubCreatedEvents.DELETED_MILESTONETEMPLATE, id => {  
            store.dispatch({
                type: types.DELETED_MILESTONETEMPLATE_INCOMING,
                payload: id
            })
        });

        h.on(hubCreatedEvents.UPDATED_MILESTONETEMPLATE, id => {         
            store.dispatch({
                type: types.UPDATED_MILESTONETEMPLATE_INCOMING,
                payload: id
            })
        });

        h.on(hubCreatedEvents.DELETED_MILESTONETEMPLATEENTRY, (id, milestoneTemplateId) => {  
            store.dispatch({
                type: types.DELETED_MILESTONETEMPLATEENTRY_INCOMING,
                payload: {
                    id, milestoneTemplateId
                }
            })
        });

        h.on(hubCreatedEvents.UPDATED_MILESTONETEMPLATEENTRY, (id, milestoneTemplateId) => {         
            store.dispatch({
                type: types.UPDATED_MILESTONETEMPLATEENTRY_INCOMING,
                payload: {
                    id, milestoneTemplateId
                }
            })
        });

         h.on(hubCreatedEvents.DELETED_PHASENOTE, (id, projectId) => {  
             store.dispatch({
                 type: types.DELETED_PHASENOTE_INCOMING,
                 payload: { id, projectId }
            })
        });

        h.on(hubCreatedEvents.UPDATED_PHASENOTE, (id, projectId) => {         
            store.dispatch({
                type: types.UPDATED_PHASENOTE_INCOMING,
                payload: { id, projectId }
            })
        });
	}

    return next => action => {     

       if (action.type === types.LOAD_USER_LOGIN_DETAILS_SUCCESS) {
            const url = '/apphub';
            setupSignalRConnection(url, onHubCreated).then(h =>
                hub = h);
        }

        if (action.type === types.USER_LOGOUT) {
            if (hub) {
                hub.stop();
            }
        }

        if (action.type === types.DELETED_USER) {            
            hub.invoke(hubMethods.DELETED_USER, action.id)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_USER_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_USER, action.user.id)
                .catch(err => console.error(err));
        }


 if (action.type === types.DELETED_CONTACT) {            
            hub.invoke(hubMethods.DELETED_CONTACT, action.contact.id, action.contact.organisationIds)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_CONTACT_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_CONTACT, action.contact.id, action.contact.organisationIds)
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_INVOICE) {            
            hub.invoke(hubMethods.DELETED_INVOICE, action.project.projectId, action.project.itemIds)
                .catch(err => console.error(err));
        }       

        if (action.type === types.CREATED_INVOICE_SUCCESS) {
            hub.invoke(hubMethods.CREATED_INVOICE, action.invoice.project.id, action.invoice.updatedItemIds)
                .catch(err => console.error(err));
        }

        if (action.type === types.DELETED_ORGANISATION) {              
            hub.invoke(hubMethods.DELETED_ORGANISATION, action.id)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_ORGANISATION_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_ORGANISATION, action.organisation.id)
                .catch(err => console.error(err));
        }

        if (action.type === types.DELETED_PHASE) {   
            hub.invoke(hubMethods.DELETED_PHASE, action.phase.id, action.phase.projectId)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_PHASE_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_PHASE, action.phase.id, action.phase.projectId)
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_PROJECT) {            
            hub.invoke(hubMethods.DELETED_PROJECT, action.id)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_PROJECT_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_PROJECT, action.project.id, action.project.complete)
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_PROJECTITEM) {            
            hub.invoke(hubMethods.DELETED_PROJECTITEM, action.projectItem.id,action.projectItem.projectId)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_PROJECTITEM_SUCCESS) {      
            hub.invoke(
                hubMethods.UPDATED_PROJECTITEM,
                action.projectItem.id,
                action.projectItem.formData.projectId)
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_PROJECTITEMACTIVITY) {            
            hub.invoke(hubMethods.DELETED_PROJECTITEMACTIVITY, action.projectItemActivity.id, action.projectItemActivity.itemId, action.projectItemActivity.projectId)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_PROJECTITEMACTIVITY_SUCCESS) {
            hub.invoke(
                hubMethods.UPDATED_PROJECTITEMACTIVITY,
                action.projectItemActivity.id,
                action.projectItemActivity.itemId,
                action.projectItemActivity.projectId
                )
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_PROJECTITEMINVOICEAMOUNT) {            
            hub.invoke(hubMethods.DELETED_PROJECTITEMINVOICEAMOUNT, action.id)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_PROJECTITEMINVOICEAMOUNT_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_PROJECTITEMINVOICEAMOUNT, action.projectItemInvoiceAmount.id)
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_PROJECTITEMMILESTONE) {            
            hub.invoke(hubMethods.DELETED_PROJECTITEMMILESTONE, action.projectItemMilestone.id, action.projectItemMilestone.itemId, action.projectItemMilestone.projectId)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_PROJECTITEMMILESTONE_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_PROJECTITEMMILESTONE,
                action.projectItemMilestone.id,
                action.projectItemMilestone.itemId,
                action.projectItemMilestone.projectId)
                .catch(err => console.error(err));
        }

        if (action.type === types.DELETED_PROJECTITEMNOTE) {            
                hub.invoke(hubMethods.DELETED_PROJECTITEMNOTE, action.note.id, action.note.itemId, action.note.projectId)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_PROJECTITEMNOTE_SUCCESS) {            
            hub.invoke(hubMethods.UPDATED_PROJECTITEMNOTE,
                    action.note.id,
                    action.note.itemId,
                    action.note.projectId
                )
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_SITE) {            
            hub.invoke(hubMethods.DELETED_SITE, action.site.id, action.site.organisationId)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_SITE_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_SITE, action.site.id, action.site.organisationId)
                .catch(err => console.error(err));
        }


 if (action.type === types.DELETED_MILESTONETEMPLATE) {            
            hub.invoke(hubMethods.DELETED_MILESTONETEMPLATE, action.id)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_MILESTONETEMPLATE_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_MILESTONETEMPLATE, action.milestoneTemplate.id)
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_MILESTONETEMPLATEENTRY) {            
     hub.invoke(hubMethods.DELETED_MILESTONETEMPLATEENTRY,
         action.milestoneTemplateEntry.id,
         action.milestoneTemplateEntry.milestoneTemplateId)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_MILESTONETEMPLATEENTRY_SUCCESS) {
            hub.invoke(hubMethods.UPDATED_MILESTONETEMPLATEENTRY,
                action.milestoneTemplateEntry.id,
                action.milestoneTemplateEntry.milestoneTemplateId)
                .catch(err => console.error(err));
        }

 if (action.type === types.DELETED_PHASENOTE) {            
            hub.invoke(hubMethods.DELETED_PHASENOTE, action.note.id, action.note.projectId)
                .catch(err => console.error(err));
        }

        if (action.type === types.UPDATED_PHASENOTE_SUCCESS) {      
            hub.invoke(hubMethods.UPDATED_PHASENOTE, action.note.id, action.note.projectId)
                .catch(err => console.error(err));
        }

        return next(action);
    }
}
export default createMySignalrMiddleWare;

